import React from 'react'
import { Helmet } from 'react-helmet'

export default ({ title = 'SOVTES-mobile' }) => (
  <Helmet>
    <meta charSet="utf-8" name="description" />
    <title>{title}</title>
  </Helmet>
)
